import React from "react";

const Title = ( {data} ) => {
    return(
        
        <header className="flex w-full gap-10 px-5 pt-5 lg:gap-0 lg:flex-row justify-between items-center">

        <button className="flex main-custom-return-button flex-shrink-0 items-center justify-center 
                relative group border-solid rounded-full lg:w-14 lg:h-14 md:w-12 md:h-12 w-8 h-8" 
                onClick={ () => window.location.replace(data.url_source) }
            >
            <img className="absolute md:p-0 p-2.5 transition-opacity duration-500 ease-linear 
                opacity-100 group-hover:opacity-0" 
                src={data.btn} alt=""
            />
            <img className="absolute md:p-0 p-2.5 transition-opacity duration-500 ease-linear 
                opacity-0 group-hover:opacity-100 rotate-180" 
                src={data.btn_hover} 
                alt=""
            />
        </button>

        <span className=" text-balance lg:text-[56px] md:text-[48px] text-[28px] lg:flex-grow lg:text-center 
                text-right" style={{color: data.color}}
            >
            {data.title}
        </span>

</header>

    );
}; 

export default Title;